import * as React from 'react';

import { translate } from '~l10n/client';
import { Divider } from '~shared/components/Divider';
import { IconDownload } from '~shared/components/icons/standard';

import { ReportOptionButton } from '../ReportOption/ReportOptionButton';
import { ReportOptionControlList } from '../ReportOption/ReportOptionControlList';
import {
  ExportReportDispatch,
  ReportOptionState,
} from '../ReportOption/ReportOptionHookReducer';
import { ReportOptionType } from '../ReportOption/ReportOptionTypes';

export const AssessmentsReportOption = ({
  header,
  reportOptions,
  optionState,
  dispatch,
  onPrepareDownload,
  isFetching,
}: {
  optionState: ReportOptionState;
  header: React.ReactNode;
  reportOptions: ReportOptionType[];
  onPrepareDownload: () => void;
  dispatch: ExportReportDispatch;
  isFetching: boolean;
}) => {
  return (
    <section className="flex flex-col justify-between h-full report-options">
      {header}
      <div className="pt-8">
        <Divider />
        <ReportOptionControlList
          shouldShowProBadge={false}
          options={reportOptions}
          dispatch={dispatch}
          optionState={optionState}
        />
        <Divider />
      </div>
      <div className="mt-15">
        <div className="flex justify-end">
          <div>
            <ReportOptionButton
              icon={<IconDownload />}
              onClick={onPrepareDownload}
              isDisabled={isFetching}
            >
              {translate('Export')}
            </ReportOptionButton>
          </div>
        </div>
      </div>
    </section>
  );
};
